import axios from 'axios'
import { z } from 'zod'
import {
  SystemCatalogCategorySchema,
  SystemCatalogCategoryType,
  SystemCatalogItemSchema,
  SystemCatalogItemStatus,
} from './system_catalog.schema'

export async function GETSystemCatalogCategories() {
  const response = await axios.get('/item_categories')
  return z.array(SystemCatalogCategorySchema).parse(response.data)
}

export type POSTSystemCatalogCategoryPayload = {
  name: string
  type: 'service' | 'good'
}

export async function POSTSystemCatalogCategory(
  payload: POSTSystemCatalogCategoryPayload
) {
  const typeAsNumber = payload.type === 'service' ? 1 : 2
  const response = await axios.post('/item_categories', {
    name: payload.name,
    type: typeAsNumber,
  })

  return response.data
}

export type PutSystemCatalogPayload = {
  id: number
  name: string
  status: SystemCatalogItemStatus
}

export async function PUTSystemCatalogCategory(
  payload: PutSystemCatalogPayload
) {
  const { id, name, status } = payload
  const statusAsNumber = status === 'Active' ? 1 : 0
  const response = await axios.put(`/item_categories/${id}`, {
    name,
    status: statusAsNumber,
  })

  return response.data
}

export type POSTSystemCatalogItemPayload = {
  name: string
  categories: string[]
  type: SystemCatalogCategoryType
}

export async function POSTSystemCatalogItem(
  payload: POSTSystemCatalogItemPayload
) {
  const typeAsNumber = payload.type === 'Service' ? 1 : 2

  const response = await axios.post('/items', {
    name: payload.name,
    categories: payload.categories,
    type: typeAsNumber,
  })

  return response.data
}

export async function GETSystemCatalogItems() {
  const response = await axios.get(`/items`)
  return z.array(SystemCatalogItemSchema).parse(response.data)
}

export async function PUTSystemCatalogItem(
  payload: Omit<POSTSystemCatalogItemPayload, 'type'> & {
    id: number
  }
) {
  const response = await axios.put(`/items/${payload.id}`, payload)
  return response
}
